import { translationUploadData_da_part1 } from "./translationUploadData.da.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationUploadData_da_part2 } from "./translationUploadData.da.part2";
import { translationUploadData_da_part3 } from "./translationUploadData.da.part3";
import { translationUploadData_da_part4 } from "./translationUploadData.da.part4";

export const translationUploadData_da = defineTranslationTree({
  ...translationUploadData_da_part1,
  ...translationUploadData_da_part2,
  ...translationUploadData_da_part3,
  ...translationUploadData_da_part4,
});
